/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the EventSubscriptions component.
 * @export
 */
export const EVENT_SUBSCRIPTIONS_DATA_IDS = {
  createButton: `Dialog button: Create event subscription`,
  searchBar: `Search filter: Search event subscriptions`,
  subscriptionName: `Button: Event subscription name`,
};
